<div class="container">
  <div class="title-container">
    <div id="product-reg-title" class="title">{{title}}</div>
    <div id="product-reg-close-btn" (click)="closeModal()" class="close-btn">
      <img src="../../../../assets/svgs/close_btn.svg" alt="close"> 
    </div>
  </div>
  <div class="body-container">
    <div class="left-body" [ngClass]="{'map-open': showMap}" >
      <div class="body-content" *ngIf="!showForm">
        <app-product-search (mapToggle)="toggleMap($event)" [search]="search" (click)="openForm = !openForm"></app-product-search>
      </div>
      <div class="form-container" [class.form-container__maps]="showMap" *ngIf="showForm">
        <form [formGroup]="form" class="form-group" [class.form-group__maps]="showMap">
          <button class="map-btn" type="button" 
          matTooltip="{{showMap ? 'Fechar mapa' : 'Abrir mapa'}}" 
          (click)="openMaps()">
            <img *ngIf="!showMap"  src="../../../../assets/svgs/map_black.svg" alt="Icones Maps"> 
            <img *ngIf="showMap" src="../../../../assets/svgs/map_red.svg" alt="Icones Maps"> 
          </button>
          <div class="form-control">
            <div class="line-column">
              <div class="form-cep">
                <div class="select">
                  <span>Tipo de imóvel / subtipo *</span>
                  <app-dropdown-button 
                    class="cep type"
                    [ngClass]="{'borderError': form.get('typeCode').invalid}"
                    [label]="titleList ? titleList : 'Selecione'"
                    [isOpen]="false" [alignRight]="false" [icon]="''"
                    [closeOnClick]="!closeDropDown" [floatOnMobile]="false" 
                    [newHeight]="true" (valueChange)="closeDropDown = $event">
                    <div class="list" *ngIf="closeDropDown">
                      <ul class="list-home" *ngFor="let item of listImoveis">
                        <p class="title-home">{{ item.title }}</p>
                        <li class="item-home" *ngFor="let type of item.listItems">
                          <a class="action-home" (click)="assigningValue(type)">{{ type.item }}</a>
                        </li>
                      </ul>
                    </div>
                  </app-dropdown-button>
                </div>
                <div class="error-input" *ngIf="form.get('typeCode').invalid">
                  <img src="../../../../assets/svgs/i_error.svg" class="icon" alt="Icon Error">
                  <span class="text-error">Campo obrigatório</span>
                </div>
              </div>
              <div class="form-cep">
                <div class="select">
                  <span>Cep *</span>
                  <app-zip-code-flag-input class="cep" [ngClass]="{'borderError': form.get('zip_code').invalid}" formControlName="zip_code"
                  [placeholder]="'00000-000'" (input)="setValue()"></app-zip-code-flag-input>
                </div>
                <div class="error-input" *ngIf="form.get('zip_code').invalid">
                  <img src="../../../../assets/svgs/i_error.svg" class="icon" alt="Icon Error">
                  <span class="text-error" *ngIf="form.get('zip_code').errors?.invalidNumber">Digite um cep válido</span>
                  <span class="text-error" *ngIf="form.get('zip_code').errors?.required">Cep requerido</span>
                </div>
              </div>
            </div>
          </div>  

          <!-- OK -->
          <div class="form-control">
            <app-input id="address" [label]="'Endereço *'"
              [messageError]="'Endereço requerido'"
              formControlName="street" [error]="form.get('street').invalid" [placeholder]="''"></app-input>
            
            <div class="number_line">
              <app-input id="number_address" [label]="'Número ou Km *'"
              [messageError]="'Número requerido'"
              formControlName="number" [error]="form.get('number').invalid" [placeholder]="'Ex: 10'"></app-input>

              <lib-input-checkbox 
              class="not_number" [id]="'not_number'" formControlName="not_number"
              name="not_number" label="Sem número" (click)="not_number()"></lib-input-checkbox>
            </div>
          </div>

          <!-- OK -->
          <div class="form-control">
            <app-input 
              id="complement" [label]="'Complemento'"
              formControlName="complement" [messageError]="''"
              [error]="false" [placeholder]="''"></app-input>
          </div>

          <!-- OK -->
          <div class="form-control" [class.form-control__maps]="showMap">
            <app-input class="bec" id="neighborhood" [label]="'Bairro *'"
              formControlName="neighborhood" [messageError]="'Bairro requerido'" 
              [error]="form.get('neighborhood').invalid" [placeholder]="'Ex: Centro'"></app-input>
            
            <app-input class="bec" id="state" [label]="'Estado'"
              formControlName="state" [messageError]="''" [error]="false" [placeholder]="'Ex: São Paulo'"></app-input>
            
            <app-input class="bec" id="city" [label]="'Cidade'"
              formControlName="city" [messageError]="''" [error]="false" [placeholder]="'Ex: São Paulo'"></app-input>
          </div>

          <!-- OK  OPTIONS -->
          <div class="form-control" *ngIf="code === 3">
            <div class="select" >
              <app-input 
                id="value_zone" formControlName="value_zone" [label]="'Zona de valor *'"
                [messageError]="'Zona de valor requerida'" [error]="form.get('value_zone').invalid" [placeholder]="''"></app-input>
            </div>

            <div class="select">
              <app-input 
                id="location_value_zones" formControlName="location_value_zones" 
                [label]="'Zona de valor (portal/marketing) *'" [messageError]="'Zona de valor (portal/marketing) requerida'"
                [error]="form.get('location_value_zones').invalid" [placeholder]="''"></app-input>
            </div>
          </div>

          <!-- OK -->
          <div class="form-control" 
            *ngIf="code === 3 || code === 17 || code === 7 || code === 8 || code === 19 || code === 38 || code === 4">
            <div class="select" >
              <app-input 
                id="geographic_area" formControlName="geographic_area" 
                [label]="'Zona geográfica *'" [messageError]="'Zona geográfica requerida'" formControlName="geographic_area"
                [error]="form.get('geographic_area').invalid" [placeholder]="''"></app-input>
            </div>
            
            <div class="select" >
              <app-input id="condominium" [label]="'Nome do condomínio *'"
                formControlName="condominium" [messageError]="'Nome do condomínio requerido'" 
                [error]="form.get('condominium').invalid" [placeholder]="''"></app-input>
            </div>
          </div>

          <!-- OK -->
          <div class="form-control" [class.form-control__maps]="showMap" *ngIf="code === 5 || code === 23">
            <app-input 
              class="bec" id="area_util" [label]="'Lote *'"
              formControlName="area_util" [messageError]="'Lote requerido'"
              [error]="form.get('area_util').invalid" [placeholder]="''"></app-input>

            <app-input 
              class="bec" id="areat_total" [label]="code === 23 ? 'Quadra' : 'Setor'"
              formControlName="areat_total" [messageError]="''"
              [error]="form.get('areat_total').invalid" [placeholder]="''"></app-input>

            <app-input 
              class="bec" id="condominium" [label]="'Condomínio'" *ngIf="code === 5"
              formControlName="condominium" [messageError]="''" 
              [error]="form.get('condominium').invalid" [placeholder]="''"></app-input>
          </div>
         
          <div class="form-control"
            *ngIf="code === 3 || code === 26 || code === 29 || code === 17 || code === 7 || code === 8 || code === 19 || code === 38 || code === 4">
            <lib-input-checkbox 
              class="singleTower" [id]="'single_tower'" formControlName="single_tower"
              name="single_tower" label="Torre única" (click)="disabledDescription()"></lib-input-checkbox>
          </div>

          <div class="form-control" [class.form-control__maps]="showMap" 
            *ngIf="(code === 3 || code === 29 || code === 17
                || code === 7 || code === 8 || code === 19 
                || code === 38 || code === 4 )">

            <app-input class="bec" id="number_name_tower" [label]="'Nome ou número da torre *'"  formControlName="number_name_tower"             
              [messageError]="'Nome ou número da torre requerido'" [error]="form.get('number_name_tower').invalid" [placeholder]="''"></app-input>

            <app-input class="bec" id="floor" [label]="'Andar *'"
              formControlName="floor" [messageError]="'Andar requerido'"
              [error]="form.get('floor').invalid" [placeholder]="''"></app-input>

            <app-input class="bec" id="unity" [label]="'Unidade *'" formControlName="unity"
              [messageError]="'Unidade requerida'" [error]="form.get('unity').invalid" [placeholder]="''"></app-input>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="showMap" class="map-container">
    </div>
  </div>
  <div class="footer-container">
    <span class="footer-msg" *ngIf="!showForm">Não encontrou o endereço?</span>
    <a *ngIf="!showForm" id="new-product-link" class="a-link" (click)="openFormModal()">Cadastre um novo</a>
    <div class="item" *ngIf="showForm">
      <lib-button-tertiary *ngIf="showForm" (click)="!showMap ? showForm = false : showMap = false">Cancelar</lib-button-tertiary>
      <lib-button-primary class="mrg-15" *ngIf="showForm" (click)="sendingDataForm()">Continuar</lib-button-primary>
    </div>
  </div>
</div>

<app-address-registry *ngIf="openForm"
  [typeModal]="1" [router]="'registro'"
  [cepValue]="'123212312'" (closeModal)="closeModalForm($event)"></app-address-registry>